import { TanStackDevtools } from "@tanstack/react-devtools";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

import { initializeAuth, redirectToLogin } from "@/stores/auth-store";
import "../styles.css";
import { Toaster } from "react-hot-toast";
import { AlertRoot } from "@/components/common/alerts";
import { MATHJAX_CONFIG, MathJaxContext } from "@/components/common/mathjax";
import { ModalRoot } from "@/components/common/modals";

export const Route = createRootRoute({
	beforeLoad: async () => {
		try {
			await initializeAuth();
		} catch {
			redirectToLogin();
		}
	},
	component: RootComponent,
	pendingComponent: AuthLoadingScreen,
});

function AuthLoadingScreen() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-slate-900">
			<div className="flex flex-col items-center gap-4">
				<div className="w-12 h-12 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin" />
				<p className="text-gray-400 text-sm">Carregando...</p>
			</div>
		</div>
	);
}

function RootComponent() {
	return (
		<MathJaxContext config={MATHJAX_CONFIG}>
			<Outlet />
			<ModalRoot />
			<AlertRoot />
			<Toaster
				position="top-right"
				reverseOrder={false}
				toastOptions={{
					style: {
						borderRadius: "12px",
						background: "var(--background)",
						color: "var(--foreground)",
						border: "1px solid var(--border)",
						fontSize: "14px",
						fontWeight: "500",
					},
					success: {
						iconTheme: {
							primary: "var(--primary)",
							secondary: "var(--primary-foreground)",
						},
					},
					error: {
						iconTheme: {
							primary: "#ff2343", // theme-red primary
							secondary: "#fff",
						},
					},
				}}
			/>
			<TanStackDevtools
				config={{ position: "bottom-right" }}
				plugins={[
					{
						name: "TanStack Router",
						render: <TanStackRouterDevtoolsPanel />,
					},
				]}
			/>
		</MathJaxContext>
	);
}
